import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VueTables__list-filter pt-2",attrs:{"id":`VueTables__${_vm.props.column}-filter`}},[_c(VSelect,{ref:"",staticClass:"font-weight-regular",class:_vm.props.theme.select,staticStyle:{"max-width":"150px"},attrs:{"dense":"","name":_vm.props.name,"value":_vm.props.value,"items":[
      { value: '', text: _vm.props.defaultOption },
      ..._vm.props.items.map(option => ({
        value: option.id,
        text: option.text
      }))
    ]},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }